export function stringNullify(obj: any) {
  if (obj === null || typeof obj !== "object" || Date.parse(obj)) {
    return obj
  }

  const result: any = Array.isArray(obj) ? [] : {}

  Object.keys(obj).forEach((key) => {
    const value = obj[key]

    if (value === "") {
      result[key] = null
    } else if (value && typeof value === "object" && !Date.parse(value)) {
      result[key] = stringNullify(value)
    } else {
      result[key] = value
    }
  })

  return result
}

export function convertEnvValueToBoolean(value?: string): boolean {
  return !value || value === "false" ? false : true
}
